export enum PlatformPermissions {
  CanImpersonate = "platform:security:loginOnBehalf",
}

export enum XApiPermissions {
  CanEditOrganization = "xapi:my_organization:edit",
  CanInviteUsers = "xapi:my_organization:user:invite",
  CanViewOrganizationOrders = "xapi:my_organization:order:view",
}
